import { ResumeSkills } from "lib/redux/types";
import React from "react";
import { TemplateSevenResumeSection } from "./common";
import {
  ResumePDFDescription,
  ResumePDFSkillsTwoColumn,
} from "../ResumePDF/common";
import { View } from "@react-pdf/renderer";
import { styles } from "../ResumePDF/styles";

const Skills = ({
  heading,
  skills,
  themeColor,
  showBulletPoints,
}: {
  heading: string;
  skills: ResumeSkills;
  themeColor: string;
  showBulletPoints: boolean;
}) => {
  const { descriptions } = skills;
  return (
    <TemplateSevenResumeSection themeColor={themeColor} heading={heading}>
      <ResumePDFDescription items={descriptions} />
    </TemplateSevenResumeSection>
  );
};

export default Skills;
